import React from 'react'
import apolloClient from './apollo'
import { ApolloProvider } from '@apollo/client'
import OrionsoftProvider from '@orionx-dev/orionsoft-parts/lib/components/Provider'
import './locale'
import PropTypes from 'prop-types'
import { ConfirmationDialog } from './ConfirmationDialog'
import Sheet from './Sheet'
import TrackProvider from 'App/helpers/track/Provider'
import UserProvider from './UserProvider'
import Version from './Version'
import DomainCheck from './DomainCheck'
import TermsVerifier from './TermsVerifier'
import ReferralCheck from './ReferralCheck'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Outlet } from 'react-router-dom'
import { Helmet } from 'react-helmet'

const Root = () => {
  return (
    <DomainCheck>
      <ApolloProvider client={apolloClient}>
        <OrionsoftProvider meProvider={false}>
          <Version />
          <UserProvider>
            <ToastContainer />
            <Helmet>
              <title>Orionx</title>
            </Helmet>
            <ConfirmationDialog>
              <ReferralCheck>
                <TermsVerifier>
                  <TrackProvider>
                    <Sheet>
                      <Outlet />
                    </Sheet>
                  </TrackProvider>
                </TermsVerifier>
              </ReferralCheck>
            </ConfirmationDialog>
          </UserProvider>
        </OrionsoftProvider>
      </ApolloProvider>
    </DomainCheck>
  )
}

Root.propTypes = {
  children: PropTypes.node,
}

export default Root
